import {useSuspenseQuery} from "@tanstack/react-query";
import {RegistrationService} from "../../services/registration-service";

export const usePendingRegistrations = (panonId: string | undefined) => useSuspenseQuery({
    queryKey: ['pending-registrations', {panonId}],
    queryFn: async () => panonId ? RegistrationService.findPendingRequestsByPanonId(panonId) : [],
});